import React from "react";
import { FieldError, RegisterOptions, UseFormRegister } from "react-hook-form";

type InputProps = {
  name: string;
  register: UseFormRegister<any>; // todo: どこかで定義したい
  value: string,
  placeholder: string;
  isSmall?: boolean; // todo: もういっそclassNameを指定させる方がいいか？
  options: RegisterOptions;
  error?: FieldError;
};

// <input>要素を含んだ子コンポーネント
export const InputHidden: React.VFC<InputProps> = (props) => {
  const { name, register, placeholder, isSmall, options, error, value } = props;

  return (
    <>
      <input
        type="hidden"
        className={
          "form-input-text" +
          (isSmall ? " small" : "") +
          (error ? " error" : "")
        }
        value={value}
        placeholder={placeholder}
        {...register(name, options)}
      />
    </>
  );
};
